export default __webpack_public_path__ + "static/zona-v@2x-11ef464b8eee247d0a92938239f76648.png";